import * as api from './api.js';
import * as types from './mutations.js';
import jwt from '../../utils/jwt';
import { MessageBox } from 'element-ui';

const paymentFailure = message => {
    MessageBox.alert(message, 'Payment Process Failure', {type: 'error'});
};

const state = {
    completed: false,
    isProcessing: false,
};

const getters = {
};

const actions = {
    register({commit, state}, {payload}) {
        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            axios.post(api.register(payload.registrationType), {...payload})
                .then(({data}) => {
                    jwt.setToken(data.authToken);
                    commit(types.SET_COMPLETED_STATUS, true);
                    state.isProcessing = false;
                    resolve();
                })
                .catch(({response}) => {
                    if (response.data.code === 402) {
                        paymentFailure(response.data.message);
                        reject(undefined);
                    } else {
                        reject(response);
                    }
                })
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    renew({commit, state}, payload) {
        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            axios.post(api.renew, payload)
                .then(({data}) => {
                    jwt.setToken(data.authToken);
                    commit(types.SET_COMPLETED_STATUS, true);
                    state.isProcessing = false;
                    resolve();
                })
                .catch(({response}) => {
                    if (response.data.code === 402) {
                        paymentFailure(response.data.message);
                        reject(undefined);
                    } else {
                        reject(response);
                    }
                })
                .done(_ => commit(types.SET_PROCESSING_STATE, false));

        });
    },
};

const mutations = {
    [types.SET_COMPLETED_STATUS](state, status) {
        state.completed = status;
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};